import React from "react";

const EmptyDivs = () => {
    return (
        <>
        <div className='empty_div'></div>
        <div className='empty_div'></div>
        <div className='empty_div'></div>
        <div className='empty_div'></div>
        <div className='empty_div'></div>
        <div className='empty_div'></div>
      </>
    );
  };
  
  export default EmptyDivs;